export enum HotelExtraFeatureType {
  PARKING = 'parking',
  VALET = 'valet',
  PETS = 'pets',
  WIRELESS = 'wireless'
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/hotel/hotel-extra-feature-type.model.ts